import {Breadcrumb, Button, Form, Modal, Input, Spin, InputNumber, Popconfirm, message, Space, Select} from "antd";
import Header from "../../components/dashboard/header";
import {DashboardOutlined, PlusSquareOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {BsBarChartSteps} from "react-icons/bs";
import {useState, useRef, useContext, useEffect} from "react"
import DataTable from "../../components/common/table";
import {
    useCreateStep,
    useDeleteStep,
    useGetAllLevels,
    useGetAllSteps,
    useUpdateStep
} from "../../hooks/payrollData/payrollDataQuery";
import RefreshContext from "../../context/refreshContext";
import {extractValueFromInputRef} from "../../helpers/dom";
import {usePVTypes} from "../../hooks/voucherTypes/voucherTypeQuery";


const stepTableColumns = [
    {
        title: "S/N",
        key: "s/n",
        render: (_, __, idx) => idx + 1
    },
    {
        title: "Title",
        key: "title",
        dataIndex: "title"
    },
    {
        title: "Value",
        key: "value",
        dataIndex: "value"
    },
    {
        title: "Benefit",
        key: "stepBenefit",
        dataIndex: "stepBenefit"
    },
    {
        title: "Level",
        key: "level",
        dataIndex: "level",
        render: (_, {level}) => level?.title
    },
    {
        title: "Actions",
        key: "actions",
        render: (_, step) => (<StepEdit step={step}/>)
    }
]


function StepEdit({step}) {
    const [isEditOpen, setIsEditOpen] = useState(false);

    const {flag, setFlag} = useContext(RefreshContext);

    const {levels} = useGetAllLevels();


    const titleRef = useRef(null);
    const valueRef = useRef(null);
    const stepRef = useRef(null);
    const [reqLevel, setReqLevel] = useState(null)

    const updateStep = useUpdateStep();
    const deleteStep = useDeleteStep();

    const confirmDeleteStep = async () => {
        await deleteStep(step.id);
        setFlag(!flag);
        message.success("Step deleted Successfully");
    }


    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            stepBenefit: stepRef.current.value,
            level: reqLevel
        }
        await updateStep(step.id, payload);
        message.success("Step updated successfully");
        setFlag(!flag);
        setIsEditOpen(false);
    }


    return (
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={() => setIsEditOpen(true)}>
                    <EditOutlined/>
                    Edit
                </Button>
                <Popconfirm
                    title="Delete this step"
                    description="Are you sure to delete this ?"
                    onConfirm={confirmDeleteStep}
                    onCancel={() => null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" danger>
                        <DeleteOutlined/>
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal title={"Update Step"} open={isEditOpen} footer={null} onCancel={() => setIsEditOpen(false)}>
                <div style={{
                    marginTop: "3em",
                    maxHeight: "70vh",
                    overflowY: "scroll",
                    paddingLeft: "1em",
                    paddingRight: "1em"
                }}>
                    <Form wrapperCol={{
                        span: 24,
                    }}
                          initialValues={{...step, level: step.level.id}}
                    >
                        <Form.Item name="title">
                            <Input ref={titleRef} placeholder="Enter Title"/>
                        </Form.Item>
                        <Form.Item name="value">
                            <Input ref={valueRef} placeholder="Enter value"/>
                        </Form.Item>
                        <Form.Item name="stepBenefit">
                            <InputNumber style={{width: "100%"}} ref={stepRef} placeholder="Enter Step"/>
                        </Form.Item>
                        <Form.Item name="level">
                            <Select showSearch placeholder="Select level" onChange={e => setReqLevel(e)}>
                                {
                                    levels.map((e, idx) => (
                                        <Select.Option key={idx} value={e.id}>
                                            {e.title}
                                        </Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button style={{backgroundColor: "green"}} size="large" type="primary" htmlType="submit"
                                    onClick={handleSubmit}>
                                Update Step
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}


export default function Step() {
    const [isOpen, setIsOpen] = useState(false);


    const createStep = useCreateStep();

    const {flag, setFlag} = useContext(RefreshContext);
    const {loading, steps} = useGetAllSteps(flag);

    const {structures} = usePVTypes()

    const [tmpSteps, setTmpSteps] = useState([])
    const [tmpLevels, setTmpLevels] = useState([])

    const [salaryStructure, setSalaryStructure] = useState(null)
    const [selectedLevel, setSelectedLevel] = useState(null)
    const {levels} = useGetAllLevels();


    const showCreateModal = () => setIsOpen(true);
    const hideCreateModal = () => setIsOpen(false);

    const titleRef = useRef(null);
    const valueRef = useRef(null);
    const stepRef = useRef(null);
    const [reqLevel, setReqLevel] = useState(null)


    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            stepBenefit: stepRef.current.value,
            level: reqLevel
        }
        await createStep(payload);
        message.success("Step Created successfully");
        setFlag(!flag);
        setIsOpen(false);
    }

    useEffect(() => {
        setTmpSteps(
            steps.filter(e => {
                if (selectedLevel != null) {
                    return e.level.id === selectedLevel
                } else {
                    return false
                }
            })
        )
    }, [selectedLevel, steps]);

    useEffect(() => {
        setTmpSteps([])
        setTmpLevels(
            levels.filter(e => e?.salaryStructure?.id === salaryStructure)
        )
    }, [salaryStructure]);

    useEffect(() => {
        setSelectedLevel(null)
    }, [tmpLevels]);


    return (
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>
                                    Dashboard
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <BsBarChartSteps/>
                                <Link to="/dashboard/step">
                                    Step
                                </Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div>
                            <Select
                                showSearch
                                placeholder="Salary Structure"
                                onChange={e => setSalaryStructure(e)}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                style={{
                                    width: 200,
                                }}
                                options={[...structures.map(s => ({value: s.id, label: s.title}))]}
                            />
                        </div>
                        <div>
                            <Select
                                showSearch
                                placeholder="Level"
                                value={selectedLevel}
                                onChange={e => setSelectedLevel(e)}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                style={{
                                    width: 200,
                                }}
                                options={[...tmpLevels.map(s => ({value: s.id, label: s.title}))]}
                            />
                        </div>
                        <div style={{display: 'flex', gap: '1em'}}>
                            {/* <UploadButton/> */}
                            <Button style={{backgroundColor: "green", color: "#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined/>
                                Add Step
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={stepTableColumns} data={tmpSteps}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal title="Add Step" open={isOpen} footer={null} onCancel={hideCreateModal}>
                <div style={{
                    marginTop: "3em",
                    maxHeight: "70vh",
                    overflowY: "scroll",
                    paddingLeft: "1em",
                    paddingRight: "1em"
                }}>
                    <Form wrapperCol={{
                        span: 24,
                    }}>

                        <Form.Item>
                            <Input
                                ref={titleRef}
                                placeholder="Enter Title" rules={[
                                {
                                    required: true,
                                    message: 'Please input title'
                                },
                            ]}/>
                        </Form.Item>
                        <Form.Item>
                            <Input placeholder="Enter Value" ref={valueRef}/>
                        </Form.Item>
                        <Form.Item>
                            <InputNumber
                                ref={stepRef}
                                style={{width: "100%"}} placeholder="Enter Step Benefit"/>
                        </Form.Item>
                        <Form.Item>
                            <Select showSearch placeholder="Select level" onChange={e => setReqLevel(e)}>
                                {
                                    levels.map((e, idx) => (
                                        <Select.Option key={idx} value={e.id}>
                                            {e.title}
                                        </Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item wrapperCol={{
                            span: 8,
                            offset: 20
                        }}>
                            <Button type="primary" onClick={handleSubmit}>
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
